/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class CaseService {
  static async getList(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'get',
        path: 'CaseNumber/getList',
        query
      }).then((result = {}) => {
        const { data } = result;
        return resolve({ isSuccess: true, data });
      });
    });
  }
  static async create(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'CaseNumber/create',
        data
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }
}
